import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Avatar from '@mui/material/Avatar';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import { Alert } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';


export default function ChatHeader({isDark,
  currDarkThemeClass,}) {

  return (
    <Box
                  sx={{
                    p: 3,
                    borderBottom: `1px solid ${isDark ? '#2B2C2B' : '#D6E797'}`,
                    bgcolor: isDark ? '#1F201E' : '#E6F1C1',
                    backdropFilter: 'blur(12px)',
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                    <Avatar
                      sx={{
                        bgcolor: isDark ? '#B1D23A' : '#819C24',
                        width: 52,
                        height: 52,
                      }}
                    >
                      <SmartToyIcon />
                    </Avatar>
                    <Box>
                      <Typography
                        variant="h5"
                        sx={{
                          fontWeight: 700,
                          color: isDark ? '#E6F1C1' : '#1A1F07',
                          letterSpacing: '-0.025em',
                        }}
                      >
                        Grow Assistance
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: isDark ? '#A1A591' : '#5D614F',
                          fontSize: '0.9rem',
                          fontWeight: 500,
                        }}
                      >
                        AI-powered cultivation support  
                      </Typography>
                    </Box>
                  </Box>
    
                  {/* <Alert
                    severity="warning"
                    icon={<WarningAmberIcon />}
                    sx={{
                      bgcolor: isDark ? 'rgba(177, 210, 58, 0.15)' : 'rgba(129, 156, 36, 0.15)',
                      color: isDark ? '#E6F1C1' : '#1A1F07',
                      border: `1px solid ${isDark ? '#B1D23A' : '#819C24'}`,
                      '& .MuiAlert-icon': {
                        color: isDark ? '#B1D23A' : '#819C24',
                      },
                    }}
                  >
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      Grow Assistance is currently in active development. Some features may behave differently as we continue to improve accuracy and coverage.
                    </Typography>
                  </Alert> */}
                </Box>
  );
}
